import RightMenuConst from './../RightMenu/const';
import LeftMenuConst from '../LeftSideBar/const';

const Const = {
    [RightMenuConst.RIGHT_MENU_IS_ACTIVE]: RightMenuConst.RIGHT_MENU_IS_ACTIVE,
    [LeftMenuConst.LEFT_SIDE_BAR_MOBILE_IS_ACTIVE]: LeftMenuConst.LEFT_SIDE_BAR_MOBILE_IS_ACTIVE,
    HEADER_SET_CURRENT_PAGE_TITLE: 'HEADER_SET_CURRENT_PAGE_TITLE'
};

export default Const;